import clsx from 'clsx';
import { Avatar } from '../../Avatar/Avatar';
import { Base } from '../../Base/Base';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "User-root_1tqQp"
};
const themesMap = {
  light: {
    color: 'anthracite'
  },
  dark: {
    color: 'white'
  }
};
function User({
  children,
  theme,
  className,
  ...extraProps
}) {
  const themeProps = typeof theme === 'string' && theme in themesMap ? themesMap[theme] : {};
  return /*#__PURE__*/_jsxs(Base, {
    tagName: "span",
    flexInline: true,
    flexAlignItemsCenter: true,
    className: clsx(styles.root, className),
    ...themeProps,
    ...extraProps,
    children: [/*#__PURE__*/_jsx(Avatar, {
      username: children,
      theme: theme,
      marginRight: "xsmall"
    }), children]
  });
}
User.displayName = 'User';
export { User };